import { render, staticRenderFns } from "./ProductsUnit.vue?vue&type=template&id=61daaf5d&scoped=true&"
import script from "./ProductsUnit.vue?vue&type=script&lang=js&"
export * from "./ProductsUnit.vue?vue&type=script&lang=js&"
import style0 from "./ProductsUnit.vue?vue&type=style&index=0&id=61daaf5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61daaf5d",
  null
  
)

export default component.exports